/* eslint-disable @typescript-eslint/no-explicit-any */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { useGLTF } from "@react-three/drei";
import { TextureLoader } from "three";
import { useLoader, useThree } from "@react-three/fiber";
import { useEffect } from "react";
export function useGLTFWithCORS(file) {
    return useGLTF(file, false, false, function (loader) {
        loader.setWithCredentials(true);
        loader.setCrossOrigin("use-credentials");
    });
}
export function useTextureWithCORS(input, options) {
    var opts = __assign({ flipY: true }, options);
    var flipY = opts.flipY;
    var gl = useThree(function (state) { return state.gl; });
    var textures = useLoader(TextureLoader, IsObject(input) ? Object.values(input) : input, function (loader) {
        loader.setWithCredentials(true);
        loader.setCrossOrigin("use-credentials");
    });
    // https://github.com/mrdoob/three.js/issues/22696
    // Upload the texture to the GPU immediately instead of waiting for the first render
    useEffect(function () {
        var array = Array.isArray(textures) ? textures : [textures];
        array.forEach(function (tex) {
            gl.initTexture(tex);
        });
    }, [gl, textures]);
    useEffect(function () {
        var e_1, _a;
        try {
            for (var _b = __values(Array.isArray(textures) ? textures : [textures]), _c = _b.next(); !_c.done; _c = _b.next()) {
                var t = _c.value;
                t.flipY = flipY;
                t.needsUpdate = true;
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    }, [textures, flipY]);
    if (IsObject(input)) {
        var keys_1 = Object.keys(input);
        var keyed_1 = {};
        keys_1.forEach(function (key) {
            var _a;
            return Object.assign(keyed_1, (_a = {},
                _a[key] = textures[keys_1.indexOf(key)],
                _a));
        });
        return keyed_1;
    }
    else {
        return textures;
    }
}
export var IsObject = function (url) {
    return url === Object(url) && !Array.isArray(url) && typeof url !== "function";
};
